export enum PersonEnum {
  MARIT = 'Marit',
  MICHELE = 'Michi',
  NADJA = 'Nadja',
  DENNIS = 'Dennis',
  JAN = 'Jan',
  CONSTANTIN = 'Constantin',
}
